<template>
  <span>
    <vue-cal
      style="height: 1000px;"
      :time-from="8 * 60"
      :time-to="23 * 60"
      :time-step="60"
      :time-cell-height="110"
      :events="slots"
      @cell-focus="selectedDate = $event"
      :overlapsPerTimeStep="false"
      resize-x
      :selected-date="
        makeABooking && searchDate ? new Date(searchDate) : selectedDate
      "
      :disable-views="['year', 'years', 'month']"
      :active-view="'day'"
    >
      <template v-slot:arrow-prev aria-hidden="true"
        ><v-icon style="width: 60px; height: 60px; padding: 10px"
          >arrow_back_ios</v-icon
        ></template
      >
      <template v-slot:arrow-next aria-hidden="true"
        ><v-icon style="width: 60px; height: 60px; padding: 10px"
          >arrow_forward_ios</v-icon
        ></template
      >
      <template v-slot:event="{ event, view }">
        <div
          :class="
            event.title === 'Available'
              ? 'vuecal__event-title '
              : 'vuecal__event-title mb-3'
          "
          v-html="event.title === 'Available' ? 'Available' : 'Booked'"
          v-show="view !== 'day'"
        />
        <div
          class="vuecal__event-content"
          v-html="
            event.title === 'Available'
              ? 'Available'
              : event.title.includes('Hold')
              ? event.title.slice(6)
              : event.title
          "
          v-show="view === 'day'"
        />
      </template>
    </vue-cal>
    <CalValidation
      :showDialog="showDialog"
      @closeDialog="closeDialog($event)"
    />
  </span>
</template>
<script>
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import CalValidation from "../Modals/CalValidation";
export default {
  name: "SlotsCalendar",
  components: { VueCal, CalValidation },
  props: {
    slots: { type: Array },
    mobile: { type: Boolean },
    makeABooking: { type: Boolean },
    searchDate: { type: String },
    duration: { type: String },
    facilitySport: { type: String },
    status: { type: String }
  },
  data: () => {
    return {
      showDialog: false,
      selectedDate: new Date()
    };
  },
  methods: {
    closeDialog(type) {
      if (type === "showDialog") {
        this.showDialog = false;
      }
    }
  }
};
</script>
<style>
.vuecal {
  height: 100%;
  overflow: hidden;
}
.tableHeader {
  border: 1px solid #dedada;
  text-align: center;
  padding: 1em;
  margin-bottom: 1em;
}
.handOver {
  cursor: pointer;
}
.Pending {
  color: #856404 !important;
  background-color: #fff3cd !important;
  border-color: #ffeeba !important;
}
.fs80 {
  font-size: 0.8em;
}
.booked {
  padding-top: 0.3rem !important;
  background-color: black !important;
  border: 1px solid white;
  margin: 1px;
  font-weight: 600;
  border-radius: 5px;
  color: white !important;
  border-width: medium;
}
.booked:hover {
  padding-top: 0.3rem !important;
  background-color: black !important;
  border: 1px solid white;
  margin: 1px;
  font-weight: 600;
  border-radius: 5px;
  color: #ffa409;
  border-width: medium;
}
.booked-right-half {
  padding-top: 0.3rem;
  background-color: rgba(255, 81, 0, 0.3);
  border: solid rgb(0, 0, 0);
  border-width: 1px;
  max-width: 50% !important;
  min-width: 50% !important;
  left: 50% !important;
  border-radius: 5%;
  z-index: 1;
}
.booked-left-half {
  padding-top: 0.3rem;
  background-color: rgba(255, 81, 0, 0.3);
  border: solid rgb(0, 0, 0);
  border-width: 1px;
  border-radius: 5%;
  max-width: 50% !important;
  min-width: 50% !important;
  left: 0% !important;
  z-index: 1;
}
.pending {
  padding-top: 0.3rem !important;
  background-color: black !important;
  border: 1px solid white;
  margin: 1px;
  font-weight: 600;
  border-radius: 5px;
  color: white;
  border-width: medium;
}
.pending:hover {
  padding-top: 0.3rem !important;
  background-color: black !important;
  border: 1px solid white;
  margin: 1px;
  font-weight: 600;
  border-radius: 5px;
  color: #ffa409;
  border-width: medium;
}
.hold {
  padding-top: 0.3rem !important;
  background-color: black !important;
  border: 1px solid white;
  margin: 1px;
  font-weight: 600;
  border-radius: 5px;
  color: white;
  border-width: medium;
}
.hold:hover {
  padding-top: 0.3rem !important;
  background-color: black !important;
  border: 1px solid white;
  margin: 1px;
  font-weight: 600;
  border-radius: 5px;
  color: #ffa409;
  border-width: medium;
}
.available-half {
  padding-top: 0.3rem;
  background-color: rgb(85, 168, 92);
  border: solid rgb(51, 71, 27);
  border-width: 1px;
  color: white;
}
.available {
  background: transparent !important;
  border-top: none;
  color: transparent !important;
  padding: 0px;
  margin: 0px;
  font-weight: 600;
  max-height: 90%;
  z-index: 10;
  cursor: pointer;
}
.available :hover {
  background-color: #ffa409 !important;
  border-radius: 5px;
  border-width: medium;
  color: black;
  padding: 0px;
  margin: 2px;
  font-weight: 600;
  padding-bottom: 30px !important;
  margin-bottom: 0px !important;
  max-height: 100%;
  z-index: 150;
}
.booked-third-start {
  padding-top: 0.3rem;
  background-color: rgba(255, 81, 0, 0.3);
  border: solid rgb(51, 71, 27);
  border-width: 1px;
  border-radius: 5%;
  left: 0px !important;
  width: 33.3%;
}
.booked-third-middle {
  padding-top: 0.3rem;
  background-color: rgba(255, 81, 0, 0.3);
  border: solid rgb(51, 71, 27);
  border-width: 1px;
  border-radius: 5%;
  left: 33.3% !important;
  width: 33.3%;
}
.booked-third-end {
  padding-top: 0.3rem;
  background-color: rgba(255, 81, 0, 0.3);
  border: solid rgb(51, 71, 27);
  border-width: 1px;
  border-radius: 5%;
  left: 66.6% !important;
  width: 33.3%;
}
.available-third-offset-left {
  padding-top: 0.3rem;
  background-color: rgb(85, 168, 92);
  border: solid rgb(51, 71, 27);
  border-width: 1px;
  color: white;
  min-width: 67% !important;
  left: 0% !important;
}
.available-third-offset-right {
  padding-top: 0.3rem;
  background-color: rgb(85, 168, 92);
  border: solid rgb(51, 71, 27);
  border-width: 1px;
  color: white;
  min-width: 67% !important;
  left: 33.3% !important;
}
.vuecal__cell-content {
  position: relative;
  width: 100%;
  height: 100%;
  outline: none;
  z-index: 2;
}
.box-shadow {
  box-shadow: inset 0 0 0 1px green;
}
.vuecal__title-bar {
  background-color: #c4e6e1 !important;
}
</style>
